"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var isArrayLike_1 = require("../utils/isArrayLike");
var BaseEntityQuery_1 = require("./BaseEntityQuery");
var PropertyQuery = /** @class */ (function (_super) {
    __extends(PropertyQuery, _super);
    function PropertyQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cleanPropertyIfArray = function (property) {
            var index = _this.options.index;
            if (typeof index === 'number' &&
                isArrayLike_1.isArrayLike(property) &&
                property[index]) {
                return property[index];
            }
            return property;
        };
        return _this;
    }
    PropertyQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    PropertyQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, entityType = _a.entityType, entityConditional = _a.entityConditional, code = _a.code, codeQuery = _a.codeQuery, key = _a.key, keyQuery = _a.keyQuery, index = _a.index, entityKey = _a.entityKey, entityIndex = _a.entityIndex, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ entityType: entityType,
            entityConditional: entityConditional,
            code: code,
            codeQuery: codeQuery,
            key: key,
            keyQuery: keyQuery,
            index: index,
            entityKey: entityKey,
            entityIndex: entityIndex }, (options.property || {}));
    };
    PropertyQuery.prototype.getRawValue = function (executionOptions) {
        var _this = this;
        var _a = this.options, code = _a.code, key = _a.key;
        return this.processEntities(executionOptions, function (entity) {
            var properties = entity && (entity.properties_pub || entity.properties);
            if (properties && properties[code]) {
                var property = properties[code].value;
                if (key === 'originalValue' && properties[code][key]) {
                    property = properties[code][key];
                }
                else if (key !== 'originalValue') {
                    property = properties[code][key || 'value'];
                }
                return _this.cleanPropertyIfArray(property);
            }
        });
    };
    return PropertyQuery;
}(BaseEntityQuery_1.BaseEntityQuery));
exports.PropertyQuery = PropertyQuery;
//# sourceMappingURL=PropertyQuery.js.map